import React from "react";

import Text from "src/components/text";

import { Analytics, CollectionItem } from "src/types/reports";

import styles from "./collectionActivityCard.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface CollectionActivityItem {
  collection: CollectionItem;
  analytics: Analytics;
}

interface CollectionActivityCardProps {
  item: CollectionActivityItem;
}

const CollectionActivityCard: React.FC<CollectionActivityCardProps> = ({
  item,
}) => {
  const { collection, analytics } = item;

  const createdBy = collection?.createdBy?.firstName
  ? `${collection.createdBy.firstName} ${collection.createdBy.lastName || ""}`.trim()
  : "Unknown";

  return (
    <a
      href={`/collections/${collection.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={collection.icon?.thumbnail || DefaultAssetIcon}
          alt={collection.name}
          className={styles.thumbnailIcon}
        />
        <div className={styles.content}>
          <Text text={collection.name} className={styles.title} lines={1} />
          <div className={styles.metrics}>
            <span>{collection.assetsCount || 0} Assets</span>
            <span>{analytics.views || 0} Views</span>
            <span>{analytics.shares || 0} Shares</span>
          </div>
          <div className={styles.meta}>
            Created by:{" "}
            <Text text={createdBy} className={styles.author} lines={1} />
          </div>
        </div>
      </div>
    </a>
  );
};

export default CollectionActivityCard;
